module.exports = __webpack_public_path__ + "img/dreamer_new2.3c6063fa.svg";